export default "__VITE_ASSET__57673b6c__"